import { DatePicker, Form, Input, InputNumber, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import InputField from '../common/Input/InputField'
import SelectField from '../common/Select/SelectField'
import dayjs from 'dayjs'
import { OPTIONS_ROLE, TIME_PAKAGE } from '../../configData'
import { userSearch } from '../../services/cmsservice'
const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)

const { TextArea } = Input

const FormPost = ({ form, handleSearch, mode }) => {
  return (
    <Form
      form={form}
      onFinish={handleSearch}
      labelAlign="left"
      labelCol={{ span: 7 }}
      layout="horizontal"
      style={{
        marginTop: 10,
        overflow: 'auto',
        overflowX: 'hidden',
        padding: '0px 10px'
      }}
      requiredMark={customizeRequiredMark}
      disabled={mode == 'VIEW' ? true : false}
    >
      <Form.Item label="" name="id" style={{ display: 'none' }}>
        <Input />
      </Form.Item>

      <Form.Item label="Tên gói nạp" name="title" rules={[{ required: true, message: 'Vui lòng nhập tên gói nạp' }]} className={styles.formItem}>
        <Input placeholder="Nhập tên gói nạp" />
      </Form.Item>
      
      {/* <Form.Item
        className={styles.formItem}
        required
        label="Loại gói"
        name="type"
      >
        <Select
          style={{ width: '100%' }}
          placeholder="Chọn gói"
        >
          {TIME_PAKAGE?.map((item, idx) => (
            <Option key={idx} value={item.value}>
              {item.name}
            </Option>
          ))}
        </Select>
      </Form.Item> */}
      <Form.Item
        label="Giá áp dụng Từ"
        name="price_from"
        rules={[
          { required: true, message: 'Vui lòng nhập!' },
          {
            validator(_, value) {
              const priceTo = form.getFieldValue('price_to')
              if (value && priceTo && value > priceTo) {
                return Promise.reject('Giá min không được lớn hơn giá max ')
              }
              return Promise.resolve()
            }
          }
        ]}
        className={styles.formItem}
      >
         <InputNumber
                  placeholder="Nhập giá áp dụng"
                  onBlur={(e) => {
                    form.setFields([
                      {
                        name: 'price_from',
                        value: e.target.value?.trim()
                      }
                    ])
                  }}
                  className={styles.InputNumber}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                  }
                  parser={(value) => value.replace(/\$\s?|(\.*)/g, '')}
                  maxLength={255}
                />
      </Form.Item>

      {/* Giá khuyến mãi */}
      <Form.Item
        label="Giá áp dụng Đến"
        name="price_to"
        rules={[
          { required: true, message: 'Vui lòng nhập!' },
          {
            validator(_, value) {
              const priceFrom = form.getFieldValue('price_from')
              if (value && priceFrom && value < priceFrom) {
                return Promise.reject('Giá max không được nhỏ hơn giá min')
              }
              return Promise.resolve()
            }
          }
        ]}
        className={styles.formItem}
      >
      <InputNumber
                  placeholder="Nhập giá khuyến mãi"
                  onBlur={(e) => {
                    form.setFields([
                      {
                        name: 'price_to',
                        value: e.target.value?.trim()
                      }
                    ])
                  }}
                  className={styles.InputNumber}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                  }
                  parser={(value) => value.replace(/\$\s?|(\.*)/g, '')}
                  maxLength={255}
                />
      </Form.Item>

      <Form.Item
        label="Phần trăm ưu đãi"
        name="preferential"
        rules={[{ required: true, message: 'Vui lòng nhập!' }]}
        // dependencies={['original_price']}
        // rules={[
        //   ({ getFieldValue }) => ({
        //     validator(_, value) {
        //       const originalPrice = getFieldValue('original_price')
        //       if (value && originalPrice && value >= originalPrice) {
        //         return Promise.reject('Giá khuyến mãi phải nhỏ hơn giá gốc!')
        //       }
        //       return Promise.resolve()
        //     }
        //   })
        // ]}
        className={styles.formItem}
      >
        <InputNumber
          style={{ width: '100%' }}
          min={0}
          max={100}
          placeholder="Nhập giá khuyến mãi"
        />
      </Form.Item>
    </Form>
  )
}

export default FormPost
